import React from "react";
import PropTypes from "kf-proptypes/widgets";

import { UserIcon, AVATAR_SIZE } from "../usericon/index.jsx";
import {
  StatusChip,
  STATUS_CHIP_COLOR,
  STATUS_CHIP_TYPE,
  CHIP_SIZES
} from "../../datadisplay/index.jsx";
import { OverflowText } from "../overflowtext/index.jsx";

import styles from "./userlist.css";

import TickIcon from "./Tick.svg";
import GroupIcon from "./Group.svg";

function Selector(props) {
  const { selected } = props;
  return (
    <div className={`${styles.selectable} ${selected ? styles.selected : ""}`}>
      {selected && <TickIcon fill="var(--kf-color-white)" />}
    </div>
  );
}

Selector.propTypes = {
  selected: PropTypes.bool
};

const USER_BADGE = {
  ServiceAccount: () => (
    <StatusChip
      color={STATUS_CHIP_COLOR.GRAY}
      type={STATUS_CHIP_TYPE.OUTLINE}
      size={CHIP_SIZES.TINY}
    >
      SA
    </StatusChip>
  )
};

/**
 * Display list of user and perform selection and deletion in that list of user.
 */

export function UserList(props) {
  const {
    dataSource,
    selectedUsers = [],
    disabledUsers = [],
    searchQuery,
    onSelect,
    onChange,
    onDelete,
    iconRenderer
  } = props;

  const selectedIds = selectedUsers.map((user) => user._id);
  const disabledIds = disabledUsers.map((user) => user._id);

  function getUserById(userId) {
    return dataSource.find((user) => user._id === userId);
  }

  return (
    <ul>
      {dataSource &&
        dataSource
          .filter((user) =>
            searchQuery ? user.Name.indexOf(searchQuery) >= 0 : true
          )
          .map((user) => {
            const chipRenderer = USER_BADGE[user.Kind];
            return (
              <li
                key={user._id}
                className={`${styles.item} ${
                  disabledIds && disabledIds.includes(user._id)
                    ? styles.disabled
                    : ""
                }`}
                data-id={user._id}
                onClick={() => {
                  if (onChange && !disabledIds.includes(user._id)) {
                    if (selectedIds.includes(user._id)) {
                      onChange(
                        selectedIds
                          .filter((userId) => userId !== user._id)
                          .map(getUserById)
                      );
                    } else {
                      onChange([
                        ...selectedIds.map(getUserById),
                        getUserById(user._id)
                      ]);
                    }
                  }
                  if (onSelect && !disabledIds.includes(user._id)) {
                    onSelect(getUserById(user._id));
                  }
                }}
              >
                {user.Kind === "Group" ? (
                  (iconRenderer && iconRenderer(user)) || (
                    <div className={styles.defaultgroup}>
                      <GroupIcon fill="var(--kf-color-gray-600)" />
                    </div>
                  )
                ) : (
                  <UserIcon
                    userId={user._id}
                    className={styles.icon}
                    size={AVATAR_SIZE.SIZE28}
                    name={user.Name}
                  />
                )}
                <span
                  className={`${styles.name} smallplus ellipsis ${styles.nameWithBadge}`}
                >
                  <OverflowText>{user.Name}</OverflowText>
                  {chipRenderer && chipRenderer()}
                </span>
                {!!onSelect && (
                  <Selector
                    selected={
                      selectedIds.includes(user._id) ||
                      disabledIds.includes(user._id)
                    }
                  />
                )}
                {!!onDelete && (
                  <button
                    className={styles.delete}
                    onClick={(e) => {
                      onDelete({ _id: user._id });
                    }}
                  />
                )}
              </li>
            );
          })}
    </ul>
  );
}

UserList.propTypes = {
  /**
   * Users details to display in lost
   */
  dataSource: PropTypes.arrayOf(
    PropTypes.shape({
      _id: PropTypes.string.isRequired,
      Kind: PropTypes.string.isRequired,
      Name: PropTypes.string.isRequired
    })
  ).isRequired,
  /**
   * selected user details
   */
  selectedUsers: PropTypes.arrayOf(
    PropTypes.shape({
      _id: PropTypes.string.isRequired,
      Kind: PropTypes.string.isRequired,
      Name: PropTypes.string.isRequired
    })
  ).isRequired,
  /**
   * disable user from the list to not perform actions
   */
  disabledUsers: PropTypes.arrayOf(
    PropTypes.shape({
      _id: PropTypes.string.isRequired,
      Kind: PropTypes.string.isRequired,
      Name: PropTypes.string.isRequired
    })
  ).isRequired,
  /**
   * search the list of users and list on results that match the search query
   */
  searchQuery: PropTypes.string,
  /**
   * function will trigger if user click radio buttion in list
   */
  onSelect: PropTypes.func,
  /**
   * function will trigger if user click the user name in the list
   */
  onChange: PropTypes.func,
  /**
   * function will trigger if user click delete icon in list
   */
  onDelete: PropTypes.func,
  /**
   * we can change the icon based on this icon render function
   */
  iconRenderer: PropTypes.func
};

UserList.defaultProps = {
  selectedUsers: [],
  disabledUsers: []
};
